import { useCallback } from 'react';

import { StyledLabel, StyledRadioButton } from '@/components/Form/styles';
import { StyledFlexRow } from '@/layout/FlexLayout';

import type { InputHTMLAttributes, ChangeEvent } from 'react';

interface RadioButtonProps<Key = string> extends InputHTMLAttributes<HTMLInputElement> {
  handleValue: (key: Key, value: string) => void;
  label?: string;
  fieldKey: Key;
}

export function RadioButton({ fieldKey, onChange, handleValue, label, ...props }: RadioButtonProps) {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (onChange) onChange(event);
      if (handleValue) handleValue(fieldKey, event.target.value);
    },
    [handleValue, fieldKey, onChange],
  );

  return (
    <StyledFlexRow>
      <StyledRadioButton type="radio" onChange={handleChange} {...props} />
      <StyledLabel>{label}</StyledLabel>
    </StyledFlexRow>
  );
}
